export default __webpack_public_path__ + "static/media/IMG_0220.d6600a58.JPEG";